import { BREAKPOINTS } from "../ApplicationConfig";
import Submitter from "../form/Submitter";
import Gallery from "../gallery/Gallery";
import Slider from "../slider/Slider";
import StandardValidator from '../form/Validator';

export default function initStaticPage()
{
    let sliderBreakpoints = {};
    sliderBreakpoints[BREAKPOINTS.SM] = {perView: 1};
    sliderBreakpoints[BREAKPOINTS.MD] = {perView: 3};    
    sliderBreakpoints[BREAKPOINTS.LG] = {perView: 3};
    sliderBreakpoints[1400] = {perView: 4};
    sliderBreakpoints[BREAKPOINTS.XXL] = {perView: 5};

    document.querySelectorAll('.js-content-slider').forEach(node => {
        let slider = new Slider(node, {
            type: 'carousel',
            gap: 0,
            perView: 5,
            keyboard: false,
            breakpoints: sliderBreakpoints,
            useScrollableDots: true,
            hideNavArrows: true,
        });

        let firstItem = node.querySelector('[data-gallery]');
        if (!firstItem) {
            return;
        }   

        new Gallery(firstItem.getAttribute('data-gallery'), slider.getRootElement());
    });

    // форма внизу страницы на большом экране
    document.querySelectorAll('.js-contact-form').forEach(node => {
        let form = node as HTMLFormElement;
        if (form !== null) {
            let validationConfig = {
                name: 'cyrillic',
                phone: 'phone',
            };

            new Submitter(form, '/request/commit/', new StandardValidator(validationConfig)).init();
        }
    });

    // форма заказа
    document.querySelectorAll('.js-order-form').forEach(node => {
        let form = node as HTMLFormElement;
        if (form !== null) {
            let validationConfig = {
                name: 'cyrillic',
                phone: 'phone',
            };

            new Submitter(form, '/order/create/', new StandardValidator(validationConfig)).init();
        }
    });
}
